import axios from 'axios';

export const reportError = async (error) => {
    try {
        await axios.post(`${process.env.REACT_APP_HOST}/errors`, {
            error: JSON.stringify({
                name: error.name,
                message: error.message,
                component: error.component || '',
                id: error.id || '',
                stack: error.stack,
            })
        });
        return true;
    } catch (e) {
        return false;
    }
};